import styled from 'styled-components';
import { HelpLabel } from 'styles/elements/label';
import { Div } from 'styles/elements/div';
import { SecondaryButton } from 'styles/elements/buttons/primaryCare';

const AnimationControl = styled(Div)`
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
`;

const AnimationToggle = styled(SecondaryButton)`
  text-decoration: ${props => props.theme.anchorTextDecoration};
  text-underline-position: under;
  white-space: nowrap;
  border: none;
  color: ${props => props.theme.anchorColor};
  text-align: left;
  padding: 5px 5px 5px 0;
  margin: 0;
`;

const ToggleText = styled(HelpLabel)`
  white-space: nowrap;
  padding: 0 5px 0 0;
  margin: 0;
`;

AnimationControl.Button = AnimationToggle;
AnimationControl.Text = ToggleText;

export default AnimationControl;
